import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";


export const CommitteeApprovalAssignmentConfig = {
    columns: [
        {
            name: "Select",
            fieldName: "isActive",
            colType: GridColumnType.CHECKBOX,
            colSettings: {
                allowEdit: true
            },
            allowShort: false
        },
        {
            name: "CPID",
            fieldName: "cpidNumber",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Course Provider Name",
            fieldName: "courseProviderName",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Submission Date",
            fieldName: "submisstionDate",
            allowShort: false,
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY',
            }
        },
        {
            name: "Staff Approval Date",
            fieldName: "staffApprovalDate",
            allowShort: false,
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY',
            }
        },
    ],
};

export const CommitteeEventListConfig = {
    columns: [
        {
            name: "Select",
            fieldName: "IsActive",
            colType: GridColumnType.CHECKBOX,
            colSettings: {
                allowEdit: true
            },
            allowShort: false
        },
        {
            name: "EventID",
            fieldName: "eventNumber",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Event Title",
            fieldName: "eventTitle",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Course Date",
            fieldName: "courseDate",
            allowShort: false,
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY',
            }
        },
        {
            name: "Staff Approval Date",
            fieldName: "staffApprovalDate",
            allowShort: false,
            colType: GridColumnType.DATE,
            colSettings: {
                format: 'DD MMM YYYY',
            }
        },
    ],
};